<template>
  <el-dialog
    :visible.sync="visible"
    :title="title"
    :width="width"
    :top="top"
    :fullscreen="fullscreen"
    :draggable="draggable"
    class="ls-select-common-dialog ls-select-user-dialog"
    :class="customClass"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    @close="close"
  >
    <div
      v-if="visible"
      class="ls-user-select-main"
      :style="{
        height: fullscreen ? '100%' : isNaN(height % 1) ? height : height + 'px'
      }"
    >
      <div class="main">
        <div class="left" :class="multiple ? '' : 'long'">
          <div class="header">
            <el-icon size="16">
              <Avatar />
            </el-icon>
            <span>可选人员</span>
          </div>
          <!--tab-->
          <div class="tab-box">
            <el-tabs v-model="activeTab" class="tab" @tab-click="changeTab">
              <el-tab-pane label="机构" name="org"></el-tab-pane>
              <el-tab-pane label="最近" name="recent"></el-tab-pane>
            </el-tabs>
            <div class="line"></div>
          </div>
          <!--tab内容-->
          <div class="left-content-box">
            <UserSelectOrg
              v-show="activeTab === 'org'"
              ref="userSelectOrg"
              :multiple="multiple"
              :selections="tableData"
              @single="checkSingle"
              @finish="orgFinish"
            ></UserSelectOrg>
            <UserSelectRec
              v-show="activeTab === 'recent'"
              ref="userSelectRec"
              :multiple="multiple"
              :selections="tableData"
              @single="checkSingle"
            ></UserSelectRec>
          </div>
        </div>
        <div v-if="multiple" class="middle">
          <el-button size="small" type="primary" @click="addUser">
            <el-icon size="16">
              <Right />
            </el-icon>
            <span>添加</span>
          </el-button>
          <el-button size="small" type="danger" @click="removeUser">
            <el-icon size="16">
              <Back />
            </el-icon>
            <span>移除</span>
          </el-button>
        </div>
        <div class="right">
          <div class="header">
            <el-icon size="16">
              <Checked />
            </el-icon>
            <span>已选人员</span>
          </div>
          <div class="ls-select-search-box">
            <div class="search-item">
              <el-input v-model="search.username" placeholder="请输入账号" clearable />
            </div>
            <div class="search-item">
              <el-input v-model="search.realName" placeholder="请输入姓名" clearable />
            </div>
          </div>
          <!--已选人员-->
          <div class="table-box">
            <el-table
              ref="checkedUserTable"
              :data="tableData"
              size="default"
              style="width: 100%"
              height="100%"
              class="ls-table"
              border
              stripe
              show-overflow-tooltip
              empty-text="暂无数据"
              :header-cell-class-name="cellClass"
              :row-class-name="setRowClass"
            >
              <el-table-column
                v-if="multiple"
                :show-overflow-tooltip="false"
                type="selection"
                width="50"
                align="center"
                fixed
              />
              <el-table-column label="账号" prop="username" width="100"></el-table-column>
              <el-table-column label="姓名" prop="realName" width="100"></el-table-column>
              <el-table-column label="信息">
                <template #default="{ row }">
                  <div class="ls-table-info-box">
                    <span>手机号 : {{ row.mobile ? row.mobile : "--" }}</span>
                    <span>座机号 : {{ row.telephone ? row.telephone : "--" }}</span>
                    <span>邮箱 : {{ row.email ? row.email : "--" }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="60" align="center" fixed="right">
                <template v-slot="{ row, $index }">
                  <span class="table-btn-delete" @click="delUser(row, $index)">移除</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="footer" :style="{ textAlign: align }">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="submit">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import UserSelectOrg from "./Org/index.vue";
import UserSelectRec from "./Rec/index.vue";
import request from "../../api/request";
export default {
  name: 'LsSelectUser',
  components: {
    UserSelectOrg,
    UserSelectRec
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "人员选择"
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "1400px"
    },
    height:{
      type: String,
      default: "650px"
    },
    top:{
      type: String,
      default: "8vh"
    },
    customClass: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: "right"
    },
    user: []
  },
  data() {
    return {
      visible: this.show,
      activeTab: "org",
      search: {
        username: "",
        realName: ""
      },
      tableData: [],
      nodeKey: "userId"
    }
  },
  watch: {
    show: {
      immediate: true,
      deep: true,
      handler(newValue) {
        // console.log(111, newValue);
        this.visible = newValue;
        this.tableData = [];
        if (this.user && this.user.length) {
          this.getCheckedUser();
        }
      }
    },
    visible(newValue) {
      if (newValue === false) {
        this.$emit("update:show", newValue);
      }
    },
  },
  methods: {
    /*获取已选人员列表*/
    async getCheckedUser() {
      try {
        // const { success, message, data } = await lsfetch.post("/api/base/users/view-list", {
        //   uniqueIds: this.user
        // });
        const { success, message, data } = await request({
          url: "/api/base/users/view-list",
          method: "post",
          data: {
            uniqueIds: this.user
          }
        });
        // const { success, message, data } = { success:false, message:"111", data:[]}
        if (!success) {
          this.$message.error("获取已选人员失败:" + message);
        }
        let temp = [];
        if (data && data.length) {
          temp = data;
        }
        this.tableData = temp;
      } catch (e) {
        this.$message.error("获取已选人员失败:" + e.message || e);
      }
    },
    /*tab切换(切换的时候需要设置表格选中/取消选中)*/
    changeTab() {
      this.$nextTick(() => {
        if (this.tableData.length > 0) {
          const temp = [];
          this.tableData.map((row) => {
            temp.push(row[this.nodeKey]);
          });
          //切换tab的时候，只将右边列表有的设置选中，没有的不设置不选中，最大限度保留用户操作
          if (this.activeTab === "org") {
            this.$refs.userSelectOrg.toggleRowSelection(temp, this.nodeKey, true);
          } else {
            this.$refs.userSelectRec.toggleRowSelection(temp, this.nodeKey, true);
          }
        }
      });
    },
    /*机构表格加载完毕*/
    orgFinish() {
      this.changeTab();
    },
    /*机构/最近单选*/
    checkSingle() {
      if (this.activeTab === "org") {
        this.tableData = this.$refs.userSelectOrg.getSelections();
        this.$refs.userSelectRec.clearTableSelection();
      } else {
        this.tableData = this.$refs.userSelectRec.getSelections();
        this.$refs.userSelectOrg.clearTableSelection();
      }
    },
    /*添加*/
    addUser() {
      let selections = [];
      if (this.activeTab === "org") {
        selections = this.$refs.userSelectOrg.getSelections();
      } else {
        selections = this.$refs.userSelectRec.getSelections();
      }
      if (selections.length === 0) {
        return this.$message.error("请选择要添加的人员");
      }
      if (this.multiple) {
        selections.map((item) => {
          const data = this.tableData.find((row) => row[this.nodeKey] === item[this.nodeKey]);
          if (!data) {
            this.tableData.push(item);
          }
        });
      } else {
        this.tableData = selections;
      }
    },
    /*移除*/
    removeUser() {
      const selections = this.$refs.checkedUserTable.selection;
      if (selections.length === 0) {
        return this.$message.error("请选择要移除的人员");
      }
      for (let i = 0; i < selections.length; i++) {
        const index = this.tableData.findIndex(
          (row) => row[this.nodeKey] === selections[i][this.nodeKey]
        );
        if (index >= 0) {
          this.$refs.userSelectOrg.toggleRowSelection([selections[i][this.nodeKey]], this.nodeKey, false);
          this.$refs.userSelectRec.toggleRowSelection([selections[i][this.nodeKey]], this.nodeKey, false);
          this.tableData.splice(index, 1);
          i--;
        }
      }
    },
    /*已选人员表格移除人员*/
    delUser(row, index) {
      this.tableData.splice(index, 1);
      this.$refs.userSelectRec.toggleRowSelection([row[this.nodeKey]], this.nodeKey, false);
      this.$refs.userSelectOrg.toggleRowSelection([row[this.nodeKey]], this.nodeKey, false);
    },
    /*单选时将表头的checkbox隐藏*/
    cellClass(row) {
      if (row.columnIndex === 0 && !this.multiple) {
        return "disabledCheck";
      }
    },
    /*已选人员表格筛选*/
    setRowClass({ row }) {
      // const username = lstool.trim(this.search.username);
      // const realName = lstool.trim(this.search.realName);
      const username = this.search.username;
      const realName = this.search.realName;
      if (username && realName) {
        if (row.username.indexOf(username) > -1 && row.realName.indexOf(realName) > -1) {
          return "row-show";
        } else {
          return "row-hide";
        }
      } else {
        if (username) {
          if (row.username.indexOf(username) > -1) {
            return "row-show";
          } else {
            return "row-hide";
          }
        } else if (realName) {
          if (row.realName.indexOf(realName) > -1) {
            return "row-show";
          } else {
            return "row-hide";
          }
        } else {
          //账号和姓名搜索框都没输入
          return "row-show";
        }
      }
    },
    /*关闭弹窗/取消*/
    close() {
      this.$emit("close");
      this.visible = false;
    },
    /*保存当前登录用户的历史选择用户配置*/
    async addHisUser() {
      const userIds = [];
      this.tableData.map((item) => {
        userIds.push(item[this.nodeKey]);
      });
      try {
        // const { success, message } = await lsfetch.put("/api-type/base/conf/his-users", userIds);
        const { success, message } = await request({
          url: "/api-type/base/conf/his-users",
          method: "put",
          data: userIds
        });
        // const { success, message } = { success: false, message: '111' }
        if (!success) {
          return this.$message.error("保存已选用户失败:" + message);
        }
      } catch (e) {
        this.$message.error("保存已选用户失败:" + e.message || e);
      }
    },
    /*确定*/
    submit() {
      if (this.tableData.length) {
        let valueArr = [],
        textArr = [],
        sourceArr = [];
        this.tableData.map((item) => {
          valueArr.push(item.userId);
          textArr.push(item.realName);
          let source = JSON.parse(JSON.stringify(item));
          sourceArr.push(source);
        });
        // this.$emit("submit", this.tableData);
        this.$emit("user-checked", {
          valueText: sourceArr.length > 0 ? valueArr.join(",") : "",
          text: textArr.join(","),
          source: sourceArr
        });
        this.visible = false;
        this.addHisUser();
      } else {
        this.$message.error("请选择人员");
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ls-select-user-dialog {
  display: flex;
  flex-direction: column;

  .ls-user-select-main {
    width: 100%;

    > .main {
      width: 100%;
      height: calc(100% - 50px);

      &:after {
        display: block;
        width: 0;
        height: 0;
        content: "";
        overflow: hidden;
        clear: both;
      }

      > .left,
      > .right {
        height: 100%;
        border-top: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
        border-radius: 4px;

        > .header {
          display: flex;
          padding: 10px;
          align-items: center;
          background-color: #f5f7fa;
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;

          > span {
            position: relative;
            top: -1px;
            margin-left: 5px;
          }
        }
      }

      > .left {
        float: left;
        width: calc((100% - 95px) * 0.6);
        box-sizing: border-box;

        &.long {
          width: 60%;
        }

        > .tab-box {
          position: relative;
          padding: 0 15px;
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;

          > .line {
            position: absolute;
            width: 100%;
            left: 0;
            bottom: -1px;
            height: 2px;
            z-index: 1;
            background-color: #ebeef5;
          }

          ::v-deep(> .tab) {
            position: relative;
            z-index: 2;

            .el-tabs__header {
              margin-bottom: 0;
            }

            /*去掉长分割线*/
            .el-tabs__nav-wrap::after {
              height: 0;
            }
          }
        }

        > .left-content-box {
          width: 100%;
          height: calc(100% - 80px);
        }
      }

      > .right {
        width: calc((100% - 95px) * 0.4);
        border-bottom: none;
        float: right;
        box-sizing: border-box;

        > .ls-select-search-box {
          border-left: 1px solid #ebeef5;
          border-right: 1px solid #ebeef5;
        }

        > .table-box {
          width: 100%;
          height: calc(100% - 101px);

          .table-btn-delete {
            color: var(--szgc-element-danger-color);
            cursor: pointer;

            &:hover {
              color: var(--szgc-element-danger-color-light);
            }
          }

          .ls-table {
            ::v-deep(.disabledCheck) {
              .cell {
                .el-checkbox {
                  display: none;
                }
              }
            }
          }

          ::v-deep(.el-table) {
            .row-show {
              display: table-row;
            }

            .row-hide {
              display: none;
            }
          }
        }
      }

      > .middle {
        float: left;
        display: flex;
        height: 100%;
        width: 70px;
        padding: 0 12px;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > .el-button {
          margin: 8px 0;
        }
      }
    }

    > .footer {
      padding-top: 16px;
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.ls-select-common-dialog {
  &.is-fullscreen {
    > .el-dialog__body {
      width: 100%;
      height: calc(100% - 40px);
    }
  }
}

.ls-select-search-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;

  > .search-item {
    flex: 1;
    margin-right: 15px;

    &:last-child {
      margin-right: 0;
    }
  }
}

.ls-table-info-box {
  overflow: hidden;

  > span {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
